<template>
  <div>
    <div class="company_img">
      <div class="company_info">
        <div>Company info</div>
        <span class="blue_line"></span>
      </div>
    </div>
    <div class="company_message">
      <p>Card Hobby was established in March 2015. </p><br>

      <p>We are the leading third party trading service platform for sports trading cards, TCG cards and all kinds of film and TV culture IP
        cards in China. </p><br>

      <p>We have consistently been focusing on the development and operation of sports card trading, Internet trading platform and
        technology solutions.</p><br>

      <p>Aiming at creating a more convenient, secure, compliant and efficient trading environment for our users, Card Hobby has launched
        both Web Client and App. </p><br>

      <p>Meanwhile, Card Hobby has also established a long-term cooperative relationship with China UnionPay, Stripe and Paypal, in order to
        provide a more reliable trading environment for our users. </p><br/>

        <p>Card Hobby is developed by Ssuper Technology INC. Our affiliates include Ssuper HongKong Technology Limited and Ssuper UK Technology Limited.</p>
        
    </div>
    <company-video class="companyvideo" />
    <div class="company_message">
      <p>The company's GMV has been continuously increasing since 2018, from 5 million RMB (nearly 700 thousand Dollars) per month to nearly
        100 million RMB (nearly 14 million Dollars) per month with more than 250,000 users worldwide. (latest data from Aug 2022)</p>
    </div>
    <div class="Milestones">
      <div class="block">
        <h1>Milestones</h1>
        <span class="blue_line"></span>
        <el-timeline>
          <el-timeline-item v-for="(activity, index) in all_companyinfo_message" :key="index" :icon="activity.icon" :type="activity.type"
            :color="activity.color" :size="activity.size" :timestamp="activity.timestamp">
            {{activity.content}}
            <div class="interval">
              {{activity.minorcontent!=null?activity.minorcontent : ''}}
            </div>
          </el-timeline-item>
        </el-timeline>
      <div class="tbc"></div>
      </div>
    </div>
  </div>
</template>

<script>
import CompanyVideo from "@/components/companyvideo";

export default {
  name: "appcompanyinfo",
  components: { CompanyVideo },
  data() {
    return {
      all_companyinfo_message: this.$enumInfo.appcompanyinfo,
    };
  },
  created() {
    document.title = 'Company info';
  },
}
</script>
    
<style scoped>
.company_img {
  background: url(../../../static/images/appcompany.jpg) no-repeat center;
  height: 240px;
  background-size: cover;
  padding: 0 12px;
  position: relative;
}
.company_info {
  margin: 0 auto;
  display: block;
  position: absolute;
  bottom: 24px;
}
.company_info > div {
  font-size: 30px;
  color: #fff;
}
.blue_line {
  width: 124px;
  height: 4px;
  background-color: #5f6dae;
  display: block;
  margin-top: 13px;
}
.company_message {
  padding: 16px 12px;
  font-size: 16px;
  text-align: center;
}
.companyvideo {
  padding: 0 12px;
}
.Milestones {
  width: 100%;
  background: url(../../../static/images/appcompany_o.jpg) repeat-y center;
  background-size: cover;
}
.block {
  padding: 24px 16px 40px 16px;
}
.block h1 {
  font-size: 20px;
  text-align: center;
}
.block .blue_line {
  width: 54px;
  height: 2px;
  margin: 0 auto;
  margin-top: 4px;
  margin-bottom: 38px;
}
.el-timeline {
  position: relative;
  left: 48px;
}
.interval {
  margin-top: 8px;
}
.el-timeline-item:nth-child(7) .interval {
  color: #5f6dae;
  font-style: italic;
}
.tbc {
  width: 100px;
  height: 50px;
  display: block;
  margin: 0 auto;
  background: url(../../../static/images/icon/TBC.png) no-repeat center;
  background-size: cover;
}
</style>


// WEBPACK FOOTER //
// src/pages/Company/appcompanyinfo.vue